import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import * as Yup from 'yup';
import { Formik } from 'formik';
import Button from "react-bootstrap/Button";
import UserService from "../services/user.service";


const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};



const ForgotPassword = (props) => {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loginValidationSchema = Yup.object().shape({
    emailaddress: Yup.string()
      .required("*Email Address is required")
  });

  
  const handleLogin = async (values, actions) => {
    console.log("VALUES", values.emailaddress);
    //if(!values.emailaddress) return;
    //setIsSubmitting(true);
    console.log("IN HANDLE LOGIN");
    var status = await UserService.forgotPassword(values.emailaddress);
    console.log("STATUS", status);
    if(status === true) {
        setMessage("Check your email for a password reset link.");
    } 
  }

  return (
    <div>
      <div className="row">
      <div className="col-sm">
      </div>
      <div className="col-sm">
        <div className="card card-container">
        Enter your email address below.  If an account exists with that email address, a password reset link will be sent to that address.
        <br/>
        <br/>
        <Formik 
        initialValues={{emailaddress: "" }}
        validationSchema={loginValidationSchema}
        onSubmit={handleLogin}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting }) => (
            <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="emailaddress">
                <Form.Label>Email Address</Form.Label>
                <Form.Control 
                  name="emailaddress"
                  type="text"
                  placeholder="Email Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.emailaddress}
                  className={touched.emailaddress && errors.emailaddress ? "error" : null}
                />
                {touched.emailaddress && errors.emailaddress ? (
                  <div className="error-message">{errors.emailaddress}</div>
                ): null}
              </Form.Group>
              <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Send Link
                </Button>
              {message && (
              <div className="form-group">
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              </div>
             )}
     
            </Form>  
      )}
    </Formik>






     
        </div>
      </div>
      </div>
    </div>
  );
};
export default ForgotPassword;